export default {
  notifications: [],
  isLoading: false,
  updatingJobIds: [],
};
